import { Component,  Input } from '@angular/core';
import { publicHelpers } from 'globals/helpers/public-helpers';
import { SocialLink } from 'globals/store/performers.data';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'social-links',
    template: `
<div (click)="publicHelpers.openInNewTab(socialLink.url)" *ngFor="let socialLink of socialLinks" class="social-icon-holder">
  <icon [icon]="'SOCIAL_' + socialLink.type"  [class]="'social_' + socialLink.type.toLowerCase()"></icon>
</div>
  `,
    styleUrls: [`./social-links.scss`],
    standalone: true,
    imports: [IconComponent, CommonModule],
})
export class SocialLinksComponent {
  publicHelpers = publicHelpers
  @Input() socialLinks: SocialLink[]
}